import { render, staticRenderFns } from "./patrolDetail.vue?vue&type=template&id=d81d0cd0"
import script from "./patrolDetail.vue?vue&type=script&lang=js"
export * from "./patrolDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d81d0cd0')) {
      api.createRecord('d81d0cd0', component.options)
    } else {
      api.reload('d81d0cd0', component.options)
    }
    module.hot.accept("./patrolDetail.vue?vue&type=template&id=d81d0cd0", function () {
      api.rerender('d81d0cd0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sai/patrol/patrolDetail.vue"
export default component.exports